import { DeliveryFeeTier } from './types';

export const DELIVERY_FEE_TIERS: DeliveryFeeTier[] = [
  { min: 0, max: 49.99, fee: 7.9 },
  { min: 50, max: 149.99, fee: 3.9 },
  { min: 150, max: Infinity, fee: 0 },
];

// TODO: update this when fuel surcharge is lifted
export const DELIVERY_FEE_TIER_LABELS = ['$8.90', '$4.90', 'FREE!'];

export const FUEL_SURCHARGE = 1;
